var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTweddle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    viewBox: "0 0 190.26 52.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{font-family:MyriadPro-Regular, 'Myriad Pro';}.cls-4{font-size:7.09px;isolation:isolate;}.cls-4,.cls-5{fill:#000;}.cls-2{letter-spacing:0em;}.cls-6{font-family:ArialHebrew-Light, 'Arial Hebrew';font-weight:300;}.cls-3{letter-spacing:0em;}.cls-7{fill:none;stroke:#000;stroke-width:.75px;}.cls-5{stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m8.51,2.42c-5.71,0-6.21,1.05-6.95,4l-.31,1.24H0L.38.03h26.08l.43,7.63h-.93l-.64-1.23c-1-2.89-1.55-4-7.26-4h-2.42v16c0,6.21.81,7.27,5,7.27v1.24H6.33v-1.3c4.16,0,5-1.06,5-7.27V2.42h-2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m47.53,18.62l4.28-12.66c1.24-3.67.68-4.72-3.29-4.72V0h11.67v1.24c-3.91,0-4.84.93-6.39,5.46l-7.08,21.23h-.81l-6.33-19.43-6.45,19.43h-.81l-6.86-21.23c-1.49-4.53-2.48-5.46-6.08-5.46V0h13.75v1.24c-3.66,0-4.66.87-3.35,4.72l4.15,12.66L40.2,0h1.18l6.15,18.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m78.46,20.61l.3-1.25h1.25l-.5,7.52h-23.19v-1.24c4.16,0,4.9-1.06,4.9-7.27v-9.93c0-6.21-.74-7.2-4.9-7.2V0h21.72l.5,7.45h-1.31l-.3-1.24c-.69-2.86-1.5-4-7.14-4h-4.16v9.25h.37c6.21,0,6.7-.74,6.7-4.9h1.24v12.1h-1.24c0-4.1-.49-4.9-6.7-4.9h-.37v3.6c0,6.2.74,7.2,4.9,7.2h.74c5.66.02,6.46-1.04,7.19-3.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m131.36,1.24V0h14.22v1.24c-4.16,0-4.91,1-4.91,7.2v8.94c0,6.2.75,7.2,4.91,7.2h2.17c5.71,0,6.45-1.06,7.2-4l.31-1.25h1.3l-.43,7.52h-24.77v-1.21c4.16,0,4.91-1.06,4.91-7.27v-9.93c0-6.21-.75-7.2-4.91-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m92.01,0h-14v1.24c4.16,0,5.71,1,5.71,7.2v18.44h8.26c10.55,0,15.15-6.09,15.15-13.48S102.56,0,92.01,0Zm.19,24.58h-.5c-3.1,0-3.54-.69-3.54-4.72V2.23h4c8.19,0,9.81,6.27,9.81,11.17s-1.58,11.18-9.77,11.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m118.35,0h-13.16v1.24c4.16,0,4.9,1,4.9,7.2v18.44h8.26c10.55,0,15.11-6.08,15.11-13.48s-4.56-13.4-15.11-13.4Zm.18,24.58h-.49c-3.11,0-3.54-.69-3.54-4.72V2.23h4c8.2,0,9.81,6.27,9.81,11.17s-1.58,11.18-9.78,11.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m176.57,19.36l-.31,1.25c-.74,2.91-1.55,4-7.2,4h-.74c-4.16,0-4.91-1-4.91-7.2v-3.61h.38c6.21,0,6.7.8,6.7,4.9h1.24V6.58h-1.27c0,4.16-.49,4.9-6.7,4.9h-.3V2.23h4.16c5.65,0,6.46,1.12,7.14,4l.31,1.24h1.31l-.5-7.45h-21.78v1.24c4.16,0,4.91,1,4.91,7.2v18.42h18.31l.5-7.52h-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m32.55,43.92v-.73h7.39v.73c-2.08,0-2.38.4-2.38,2.91v1.7c-3,0-4,1.31-6.52,1.31-4.39-.49-7.55-4.45-7.06-8.84.42-3.71,3.35-6.64,7.06-7.06,1.79.03,3.48.8,4.67,2.14.35-.4.58-.9.65-1.43h.7v5.51h-.73c-.67-3.26-2.71-5-5.19-5-3.43,0-4.41,3.63-4.41,6.74s1,6.75,4.41,6.75c2,0,3.76-.81,3.76-3.11,0-1.09-.62-1.62-2.35-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m51.85,45.48c2.21,2.43,3.16,3,4.69,3.21v.72h-5.44l-4.47-6.61h-.72v3c0,2.51.32,2.94,2.4,2.94v.72h-7.92v-.72c2.08,0,2.38-.43,2.38-2.94v-7.77c0-2.51-.3-2.93-2.38-2.93v-.73h8.4c3.11,0,5.06,1.91,5.06,4.24,0,2.18-1.7,4-4.43,4.21l2.43,2.66Zm-1.39-6.87c.11-1.61-1.11-3.01-2.73-3.12-.16-.01-.32,0-.48,0h-1.34v6.19h1.38c1.61.14,3.02-1.05,3.16-2.65.01-.14.01-.28,0-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.26,49.8c-4.41-.21-7.82-3.96-7.61-8.37s3.96-7.82,8.37-7.61c4.28.2,7.64,3.75,7.62,8.03-.13,4.5-3.88,8.06-8.38,7.95Zm0-14.69c-3.53,0-5,3.71-5,6.74s1.46,6.75,5,6.75,5-3.71,5-6.75-1.44-6.7-5-6.7v-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m86.95,35.1v-.73h6.14v.73c-2.08,0-2.38.42-2.38,2.93v5.77c0,3.33-2.7,6.03-6.03,6.03s-6.03-2.7-6.03-6.03h0v-5.77c0-2.51-.33-2.93-2.41-2.93v-.73h8v.73c-2.11,0-2.41.42-2.41,2.93v5.52c0,3.23,1.73,4.73,3.89,4.73s3.68-1.5,3.68-4.73v-5.52c-.05-2.51-.35-2.93-2.45-2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m107.95,38.61c0,2.33-1.95,4.21-5.06,4.21h-2.88v2.98c0,2.51.32,2.94,2.4,2.94v.72h-7.95v-.72c2.08,0,2.38-.43,2.38-2.94v-7.77c0-2.51-.3-2.93-2.38-2.93v-.73h8.4c3.14,0,5.09,1.91,5.09,4.24Zm-3.36,0c.11-1.61-1.11-3.01-2.73-3.12-.16-.01-.32,0-.48,0h-1.37v6.19h1.37c1.6.17,3.03-.99,3.2-2.59.02-.16.02-.33.01-.49Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    y1: 41.92,
    x2: 18.26,
    y2: 41.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 113.03,
    y1: 41.92,
    x2: 177.19,
    y2: 41.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m183.54.47v4.58h-.56V.47h-1.52v-.47h3.58v.47h-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m189.78,5.05V.43h0l-1.42,4.62h-.43l-1.47-4.62h0v4.62h-.51V0h.87l1.29,4.09h0L189.38,0h.88v5.05h-.48Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(137.41 50.18)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 0,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 4.14,
    y: 0
  }, "JK"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 10.61,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 12.58,
    y: 0
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 17.16,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 20.99,
    y: 0
  }, "OUP")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTweddle);
export default __webpack_public_path__ + "static/media/tweddle.b3d48f1190b8ce188e1dcc5ecac4a741.svg";
export { ForwardRef as ReactComponent };